import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8203776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "btns2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交试卷")
const _hoisted_4 = { class: "contentBox" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "center" }
const _hoisted_8 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavTop = _resolveComponent("NavTop")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LeftTopic = _resolveComponent("LeftTopic")!
  const _component_Content = _resolveComponent("Content")!
  const _component_RightTips = _resolveComponent("RightTips")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavTop),
    _createElementVNode("div", {
      class: "popupBox",
      style: _normalizeStyle(`z-index: ${_ctx.popupShow ? 2 : -1}`)
    }, [
      (_ctx.popupShow)
        ? (_openBlock(), _createBlock(_component_Popup, {
            key: 0,
            onClose: _ctx.close,
            popupType: _ctx.popupType,
            state: _ctx.state
          }, null, 8, ["onClose", "popupType", "state"]))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        round: "",
        color: "#50212F",
        size: "large",
        onClick: _ctx.submitPaper
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_LeftTopic)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Content, { ref: "content" }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_RightTips, { ref: "rightTips" }, null, 512)
        ])
      ])
    ])
  ]))
}